import React from 'react';
import { motion } from 'framer-motion';
import manufacturingImg from '../images/photos/manufacturer.gif'; // replace with your actual image path

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 }
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20
};

const Industries_Manufacturing = () => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    style={{
      minHeight: '60vh',
      padding: '20px',
      fontFamily:
        "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    {/* Page Heading */}
    <h1
      style={{
        fontSize: '34px',
        marginBottom: '24px',
        textAlign: 'center',
        color: '#1e293b'
      }}
    >
      Manufacturing
    </h1>

    <section
      style={{
        maxWidth: '1200px',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      {/* Left: Image */}
      <div style={{ flex: '1 1 300px', display: 'flex', justifyContent: 'center' }}>
        <img
          src={manufacturingImg}
          alt="Manufacturing sector"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
          }}
        />
      </div>

      {/* Right: Content */}
      <div style={{ flex: '1 1 300px' }}>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Transforming Manufacturing Operations for a Smarter Future. Zyntro Software Solutions Pvt.
          Ltd. provides cutting-edge technology solutions designed to streamline and enhance
          operations in the manufacturing industry. We specialize in digital transformation
          services, ranging from supply chain management and production optimization to predictive
          maintenance and IoT integration. Our goal is to help manufacturing businesses reduce
          costs, improve efficiency, and maintain high-quality standards while adapting to the
          rapidly evolving industry landscape.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          By leveraging advanced technologies such as IoT, AI, and data analytics, we empower
          manufacturers to make smarter decisions, optimize their production processes, and achieve
          greater operational efficiency. Whether you’re looking to automate tasks, monitor
          equipment health, or optimize your supply chain, Zyntro Software Solutions Pvt. Ltd.
          offers scalable, secure, and customized solutions that drive growth and innovation in
          manufacturing.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          From small-scale manufacturers to large industrial enterprises, we are your trusted
          partner in navigating the future of manufacturing through smart, technology-driven
          solutions.
        </p>
      </div>
    </section>
  </motion.div>
);

export default Industries_Manufacturing;
